import { unAuthorized } from 'redux/actions'

export const handleUnAuthorized = (dispatch) => {
  dispatch(unAuthorized())
}
